module.exports = __webpack_public_path__ + "img/coin_1.12f3f838.png";